import { render, staticRenderFns } from "./zszcDetail.vue?vue&type=template&id=43f40f2c&scoped=true&"
import script from "./zszcDetail.vue?vue&type=script&lang=js&"
export * from "./zszcDetail.vue?vue&type=script&lang=js&"
import style0 from "./zszcDetail.vue?vue&type=style&index=0&id=43f40f2c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f40f2c",
  null
  
)

export default component.exports